import { Validator } from 'vee-validate'
import env from '../store/base/config/env'

const passwordStrength = env.VUE_APP_PASSWORD_STRENGTH

const has_lower = /[a-z]/
const has_upper = /[A-Z]/
const has_number = /\d/
const has_special = /[^a-zA-Z0-9\r\n]/
const has_letter = /[a-zA-Z]/

function validate_password(password) {
    // validate length 8 - 20 chars
    if (passwordStrength > 0) {
        if (password.length < 8) {
            return 'Needs at least 8 characters'
        }
        if (password.length >= 20) {
            return 'Needs at most 20 characters'
        }
    }

    // requires number + alpha
    if (passwordStrength > 1) {
        if (!has_letter.test(password)) {
            return 'Requires a letter'
        }
        if (!has_number.test(password)) {
            return 'Requires a number'
        }
    }

    // requires lower + upper
    if (passwordStrength > 2) {
        if (!has_lower.test(password)) {
            return 'Requires a lowercase'
        }
        if (!has_upper.test(password)) {
            return 'Requires an uppercase'
        }
    }

    // requires special
    if (passwordStrength > 3) {
        if (!has_special.test(password)) {
            return 'Requires a special character'
        }
    }

    return true
}

const password_rule = {
    getMessage: (field, params, data) => data.message,
    validate: (value) => {
        var message = validate_password(value)
        var valid = message === true
        return {
            valid,
            data: message === true ? undefined : { message }
        }
    }
}
Validator.extend('password', password_rule)

const minCount = {
    getMessage: (field, { min }, data) => `${field} needs at least ${min} entries.`,
    validate: (value, { min }) => {
        return value.length >= min
    }
}

Validator.extend('minCount', minCount, { paramNames: ['min'] })

const phone_regex = /\({0,1}((0|\+61)(\s+)?(2|4|3|7|8)){0,1}\){0,1}( |-|.){0,1}[0-9]{2}( |-|.){0,1}[0-9]{2}( |-|.){0,1}[0-9]{1}( |-|.){0,1}[0-9]{3}/
const phone_rule = {
    getMessage: (field, params, data) => `Invalid phone number`,
    validate: (value, params) => {
        return phone_regex.test(value)
    }
}

Validator.extend('phone', phone_rule)
